// Bộ đếm số lần một đợt cập nhật bị "stalled" (SW mới không nắm được quyền) trong
// PHIÊN của tab hiện tại. Dùng để chặn vòng lặp recovery vô hạn: sau MAX lần thất
// bại thì dừng tự động và hướng dẫn người dùng đóng toàn bộ tab.
//
// Vì sao sessionStorage (không phải localStorage):
//  - Sống sót qua F5 trong cùng tab.
//  - Tách biệt giữa các tab -> tab này không phá bộ đếm của tab kia.
//  - Tự xoá khi đóng tab -> đợt cập nhật tương lai luôn bắt đầu lại từ 0.
//
// QUAN TRỌNG: chỉ TĂNG khi thật sự stalled (thất bại), KHÔNG tăng ở mỗi lần cập
// nhật. Và RESET khi cập nhật thành công (controllerchange) hoặc khi trang tải mới
// không có SW điều khiển (sau hard-recovery / lần đầu). Nhờ vậy một tab mở lâu trải
// qua nhiều đợt cập nhật lành mạnh sẽ không bao giờ vô cớ chạm ngưỡng terminal.

export const STALL_ATTEMPT_KEY = "sw-update-stall-attempts";
export const MAX_UPDATE_ATTEMPTS = 3;

// Dự phòng khi sessionStorage không khả dụng (chế độ riêng tư / bị chặn).
let memoryFallback = 0;

export function getUpdateAttempts(): number {
  try {
    return Number(sessionStorage.getItem(STALL_ATTEMPT_KEY)) || 0;
  } catch {
    return memoryFallback;
  }
}

export function bumpUpdateAttempts(): number {
  const next = getUpdateAttempts() + 1;
  memoryFallback = next;
  try {
    sessionStorage.setItem(STALL_ATTEMPT_KEY, String(next));
  } catch {
    /* dùng memoryFallback */
  }
  return next;
}

export function resetUpdateAttempts(): void {
  memoryFallback = 0;
  try {
    sessionStorage.removeItem(STALL_ATTEMPT_KEY);
  } catch {
    /* bỏ qua */
  }
}